import { PRICE_SCENARIOS } from "@circle-react/helpers/paywallPriceHelpers";
import type { PaywallCheckoutPreview } from "@circle-react/types";

export const getNumberOfInstallments = (preview: PaywallCheckoutPreview) => {
  if (
    [
      PRICE_SCENARIOS.upfrontThenTrialThenValue,
      PRICE_SCENARIOS.trialThenUpfrontThenValue,
      PRICE_SCENARIOS.upfrontThenValue,
    ].includes(preview.preview_scenario)
  ) {
    return 1 + (preview?.remaining_payments?.installments_preview?.length || 0);
  }

  // value
  return (
    1 +
    (preview.future_payments ? 1 : 0) +
    (preview?.remaining_payments?.installments_preview.length || 0)
  );
};

export const isOneInstallment = (preview: PaywallCheckoutPreview) =>
  getNumberOfInstallments(preview) === 1;

export const shouldExpandFuturePayments = (preview: PaywallCheckoutPreview) =>
  preview.future_payments &&
  (preview.future_payments.discount < 0 || preview.future_payments.tax > 0);

export const shouldExpandPayment = (
  payment:
    | PaywallCheckoutPreview["first_payment"]
    | PaywallCheckoutPreview["future_payments"],
) => payment && (payment.discount < 0 || payment.tax > 0);
